import { routenames } from '@/router/routenames';
import type { NavigationEntryRaw } from '../types';

export const medicalSystemsNavigationRaw: NavigationEntryRaw[] = [
  {
    titleI18n: 'Task_other',
    route: { name: routenames.tasks.index },
  },
  {
    titleI18n: 'Entity_other',
    route: { name: routenames.medicalSystems.index },
  },
];
